import { render, staticRenderFns } from "./EditarTalonario.vue?vue&type=template&id=16a3efa5"
import script from "./EditarTalonario.vue?vue&type=script&lang=js"
export * from "./EditarTalonario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports